import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { slimTier } from '../../../constants/form'
import useAltModule from '../../../hooks/useAltModule'
import { notUndefinedNull, isActualRequestSuccessOrRejected } from '../../../helpers/shared'
import { useModule } from '../../../hooks/useTier'
import { Title } from '../../shared/simple/Title'
import { useTextLanguage } from '../../../hooks/useShared'
import { useDescription } from '../../../hooks/useProducts'
import { Alert } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import IbvDialog from '../../tier/ibv/IbvDialog'
import { useIbvDialog } from '../../../hooks/useIbvDialog'
import { ModuleContext } from '../../../context/ModuleContext'
import { Form } from '../../tier/Form'
import { useSpeedTier } from '../../../hooks/useTier'

const AltModule = ({
	shouldShowIBV,
	setAlert
}) => {
	const params = useParams()
	const {
		allAssistants,
		selectedAssistant,
		needAssistant,
		tier,
		categoriesTier,
		tierFieldState
	} = useModule()
	const { isUsed } = useSelector(state => state.base.autoLoginURL) || {}
	const isSlimAdvanced = params?.codeTier && (params.codeTier === slimTier)
	const { isIBVVerified, isIBVRequired } = useSelector(state => state.base.ibv)
  const isIBVCompletedOrNotRequired = !isIBVRequired || isIBVVerified
	const { description  } = useTextLanguage();
	const { flagRequest } = useDescription()
	const { t } = useTranslation()
	const { dataProductRequest, lastProductRequestId } = useSelector(state => state?.user);
	
	const { BackBtn, MainContainer, InnerContainer } = useAltModule()
	const {
		open,
		handleClose, 
		handleOpen,
		requestWidgetURL
	} = useIbvDialog({setAlert})
	useSpeedTier()

  return (
			<InnerContainer id='container-scrollable'>
					<Col className="p-0 text-end" xs={12}>
						{
							((!isUsed) || !isSlimAdvanced || isIBVCompletedOrNotRequired) && BackBtn
						}
					</Col>
					<Col className="p-4 pb-1 pt-1" xs={12}>
							{(notUndefinedNull(selectedAssistant)) &&
								<StaticMessage
								variant="info"
								message={ t("assistants.assignedAssistant", { name: `${
									selectedAssistant.first_name} ${selectedAssistant.last_name}` }) }
								/>
							}
							{(needAssistant && isUndefinedNull(selectedAssistant)) &&
								<StaticMessage
								variant="warning"
								message={ `${t("assistants.needAssistant")}` }
								/>
							}
					</Col>
					<Col className="p-4 pt-0 pb-1" xs={12}>
							<Title className="pb-1" id='scrollable-title'>
								{ tier[description] }
							</Title>
					</Col>
						{(flagRequest) && (
							<Col className="p-3" xs={12}>
								<Alert variant={'warning'}>
								{t("common.updateDataWarningMessage")}
								</Alert>
							</Col>
						)}
						{(isActualRequestSuccessOrRejected(dataProductRequest, lastProductRequestId)) && (
							<Col className="p-3" xs={12}>
								<Alert variant={'warning'}>
								{t("common.createNewRequestWarning")}
								</Alert>
							</Col>
						)}
						{/* //! For some reason, this started coming as true */}
						{(shouldShowIBV) && (
							<Col className="p-3" xs={12}>
								<IbvDialog
									setAlert={setAlert}
									open={open}
									handleClose={handleClose}
									handleOpen={handleOpen}
									requestWidgetURL={requestWidgetURL}
								/>
							</Col>
						)}

						{/* Form will be here */}
						<ModuleContext.Provider
							value={[ categoriesTier, tier, tierFieldState ]}
						>
							<Form 
								handleOpenIbv={handleOpen}
								className={'p-4 pt-5'}
							/>
						</ModuleContext.Provider>

						{/* Form */}

						{(allAssistants?.length !== 0 && notUndefinedNull(
							allAssistants) && isUndefinedNull(selectedAssistant)) && (
							<FloatButton
								className="btn"
								type="submit"
								color="first"
								onClick={() => setModalIsOpen(true) }
							>
								<FontAwesomeIcon icon={ faHeadset } size="2x"/>
							</FloatButton>
						)}
			</InnerContainer>
  )
}

export default AltModule